import type { ShipmentSearchFilters, InvoiceSearchFilters } from '../types';

export const pcKeys = {
  all: ['planete-courrier'] as const,

  shipments: () => [...pcKeys.all, 'shipments'] as const,
  shipmentList: (filters: ShipmentSearchFilters) => [...pcKeys.shipments(), 'list', filters] as const,
  shipmentDetail: (number: string) => [...pcKeys.shipments(), 'detail', number] as const,
  // Nested under shipments() so confirm/cancel invalidations refresh this list too.
  quoteShipments: (quoteId: string) => [...pcKeys.shipments(), 'quote', quoteId] as const,

  invoices: () => [...pcKeys.all, 'invoices'] as const,
  invoiceList: (filters: InvoiceSearchFilters) => [...pcKeys.invoices(), 'list', filters] as const,

  accounts: () => [...pcKeys.all, 'accounts'] as const,
  aging: (accountNumber: string) => [...pcKeys.all, 'aging', accountNumber] as const,

  carriers: () => [...pcKeys.all, 'carriers'] as const,
  packageStatuses: () => [...pcKeys.all, 'package-statuses'] as const,
  pickupInstructions: (carrierCode: string) => [...pcKeys.all, 'pickup-instructions', carrierCode] as const,
  // Eligible pickups are draft+service scoped (a Purolator pickup cannot collect
  // a PC-courier box), so both ids key the cache entry.
  eligiblePickups: (draftId: number | null, serviceAgreementId: number | null) =>
    [...pcKeys.all, 'eligible-pickups', draftId, serviceAgreementId] as const,

  packagePresets: () => [...pcKeys.all, 'package-presets'] as const,
};
